import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, Col, Row } from 'reactstrap'
import { urlConsultarPlaca } from '../../constants/urls'
import EmisionRetroactiva from '../CotizacionPymes/EmisionRetroactiva'
import Recargos from '../CotizacionPymes/Recargos'
import ValoresParametrico from './ValoresParametrico'
import EsRenovacion, { guardarRenovacion } from '../EsRenovacion/EsRenovacion'


const ComponentResumenParametrico = ({
    datosContratanteAux,
    datosSeleccionadosAux,
    guardarInformacion,
    onRegresar,
    planSeleccionado,
    datosCarrito,
    preguntas,
    loading,
    setLoading,
    duplicado,
    setDuplicado,
    setMensajeDuplicado,
    mensajeDuplicado,
    cotizadorId,
    requiereEmisionRetroactiva,
    ramoNombre,
    aplicaRecargos,
    aplicaObservaciones,
    mensajeRecargos,
    requiereRecargos,
    setRequiereRecargos,
    recargoSeleccionado,
    setRecargoSeleccionado,
    recargos,
    recargoModificado,
    setRecargoModificado,
    recalcularCoberturas,
    mensajeObservaciones,
    requiereObservacion,
    setRequiereObservacion,
    observacion,
    setObservacion,
    observacionValida,
    setObservacionValida,
    mensajeObservacion,
    requiereObservacionObligatoria
}) => {



    const [datosContratante, setDatosContratante] = useState([])
    const [datosSeleccionados, setDatosSeleccionados] = useState([])
    const [vigenciaRetroactiva, setVigenciaRetroactiva] = useState(new Date())
    const [errorVigenciaRetroactiva, setErrorVigenciaRetroactiva] = useState(false)
    const [requiereEmision, setRequiereEmision] = useState(false)
    const [ramfecFuturo, setRamfecFuturo] = useState(null)
    const [ramfecRetroactividad, setRamfecRetroactividad] = useState(null)

    const [esRenovacion, setEsRenovacion] = useState(false)

    const [requiereRenovacion, setRequiereRenovacion] = useState(cotizadorId == 'guardiasDobleVigenciaAmparo' || cotizadorId == 'gasolineraGeneral')

    const [numPolizaVence, setNumPolizaVence] = useState(null)
    const [tieneError, setTieneError] = useState(true)



    useEffect(() => {


        var categoriasAux = []
        var datosAux3 = []
        preguntas.forEach(categoria => {

            categoria.preguntas.forEach(pregunta => {
                categoriasAux.push(pregunta)




            });



            categoriasAux.forEach(element => {

                if (element.cuesTipo == 'select' || element.cuesTipo == 'web') {


                    if (element.value && element.cuesMultiple == 'SI') {
                        var aux = []
                        element.value.forEach(valor => {

                            aux.push(valor.label)
                        });


                        var objetoAux = {
                            tipo: element.cuesTipo,
                            titulo: element.cuesPregunta,
                            valor: aux.join()
                        }
                        datosAux3.push(objetoAux)

                    } else {
                        var objetoAux = {
                            tipo: element.cuesTipo,
                            titulo: element.cuesPregunta,
                            valor: element.value ? element.value.label : ''
                        }
                        datosAux3.push(objetoAux)
                    }


                }
                if (element.cuesTipo == 'texto' || element.cuesTipo == 'textarea' || element.cuesTipo == 'numerico' || element.cuesTipo == 'SINO' || element.cuesTipo == 'archivo') {
                    var objetoAux = {
                        tipo: element.cuesTipo,
                        titulo: element.cuesPregunta,
                        valor: element.value
                    }
                    datosAux3.push(objetoAux)
                }

            });
        });


        setDatosSeleccionados(eliminarDuplicadosPorTitulo(datosAux3))
        var datosAux = []

        if (datosContratanteAux) {
            for (const key in datosContratanteAux) {
                const element = datosContratanteAux[key];

                if (element.tipo == 'select') {
                    var objetoAux = {
                        tipo: element.cuesTipo,
                        titulo: element.label,
                        valor: element.value.label
                    }
                    datosAux.push(objetoAux)
                }
                if (element.tipo == 'text' || element.tipo == 'textarea' || element.tipo == 'number' || element.tipo == 'date') {
                    var objetoAux = {
                        tipo: element.cuesTipo,
                        titulo: element.label,
                        valor: element.value
                    }
                    datosAux.push(objetoAux)
                }

            }


            setDatosContratante(datosAux)
        }

        var datosAux2 = []

        if (datosSeleccionadosAux) {
            for (const key in datosSeleccionadosAux) {
                const element = datosSeleccionadosAux[key];


                if (element.tipo == 'select') {

                    var objetoAux = {
                        titulo: element.label,
                        tipo: element.cuesTipo,
                        valor: element.value.label
                    }
                    datosAux2.push(objetoAux)
                }
                if (element.tipo == 'text' || element.tipo == 'textarea' || element.tipo == 'number') {
                    var objetoAux = {
                        titulo: element.label,
                        tipo: element.cuesTipo,
                        valor: element.value
                    }
                    datosAux2.push(objetoAux)
                }

            }

            setDatosSeleccionados(eliminarDuplicadosPorTitulo(datosAux2))
        }

    }, [datosContratanteAux])

    function eliminarDuplicadosPorTitulo(array) {
        const uniqueMap = new Map();
        array.forEach(obj => {
            const titulo = obj.titulo;
            if (!uniqueMap.has(titulo)) {
                uniqueMap.set(titulo, obj);
            }
        });
        const uniqueArray = Array.from(uniqueMap.values());
        return uniqueArray;
    }




    return (
        <Row>
            <Col lg={8}
                md={12}
                sm={12}
                xs={12}
                className="detalle-cotizacion-box">
                <Card>
                    <CardBody>
                        <h4>Resumen</h4>
                        <hr></hr>
                        {datosContratante && datosContratante.map(dato => {
                            return (
                                <Row>
                                    <Col sm={6} md={6}><p>{dato.titulo == 'Dirección de residencia habitual' ? 'Plan agregado Hogar aliado' : dato.titulo}</p></Col>
                                    <Col sm={6} md={6}>
                                        {dato.tipo == 'archivo' ?
                                            <a href={dato.valor}>Descargar archivo</a>
                                            :
                                            <p>{dato.valor}</p>
                                        }

                                    </Col>
                                </Row>
                            )
                        })}

                    </CardBody>
                </Card>

                <Card>
                    <CardBody>
                        <h4>Opción seleccionada</h4>
                        <hr></hr>
                        {datosSeleccionados && datosSeleccionados.map(dato => {
                            return (
                                <Row>
                                    <Col sm={6} md={6}><p>{dato.titulo}</p></Col>
                                    <Col sm={6} md={6}>
                                        {dato.tipo == 'archivo' ?
                                            <a href={dato.valor}>Descargar archivo</a>
                                            :
                                            <p>{dato.valor}</p>
                                        }
                                    </Col>
                                </Row>
                            )
                        })}

                        {planSeleccionado &&


                            <Row>
                                <Col sm={6} md={6}><p>{'Plan seleccionado'}</p></Col>
                                <Col sm={6} md={6}><p>{planSeleccionado}</p></Col>
                            </Row>

                        }

                    </CardBody>
                </Card>

                {requiereRenovacion &&
                    <EsRenovacion
                        esRenovacion={esRenovacion}
                        setEsRenovacion={(esRenovacion) => {
                            setEsRenovacion(esRenovacion)


                        }}
                        numPolizaVence={numPolizaVence}
                        setNumPolizaVence={(value) => {
                            setNumPolizaVence(value)
                        }}
                        tieneError={tieneError}
                        setTieneError={(value) => {
                            setTieneError(value)
                        }}
                    />

                }






                {requiereEmisionRetroactiva && ramoNombre != '' &&

                    <EmisionRetroactiva
                        ramo={ramoNombre}
                        mensaje={'¿Se requiere la emisión con una vigencia futura? Por favor seleccionar únicamente en caso de necesitarlo'}
                        vigenciaRetroactiva={vigenciaRetroactiva}
                        setVigenciaRetroactiva={(valor) => { setVigenciaRetroactiva(valor) }}
                        requiereEmision={requiereEmision}
                        setRequiereEmision={(valor) => { setRequiereEmision(valor) }}
                        setLoading={(valor) => { setLoading(valor) }}
                        ramfecFuturo={ramfecFuturo}
                        ramfecRetroactividad={ramfecRetroactividad}
                        setRamfecFuturo={(valor) => { setRamfecFuturo(valor) }}
                        setRamfecRetroactividad={(valor) => { setRamfecRetroactividad(valor) }}
                        errorVigenciaRetroactiva={errorVigenciaRetroactiva}
                        setErrorVigenciaRetroactiva={(valor) => { setErrorVigenciaRetroactiva(valor) }}
                    />

                }

                {(aplicaObservaciones) &&

                    <Recargos
                        aplicaObservaciones={aplicaObservaciones}
                        aplicaRecargos={false}
                        mensajeRecargos={mensajeRecargos}
                        requiereRecargos={requiereRecargos}
                        setRequiereRecargos={(valor) => { setRequiereRecargos(valor) }}
                        recargoSeleccionado={recargoSeleccionado}
                        setRecargoSeleccionado={(valor) => { setRecargoSeleccionado(valor) }}
                        recargos={recargos}
                        recargoModificado={recargoModificado}
                        setRecargoModificado={(value) => { setRecargoModificado(value) }}
                        recalcularCoberturas={() => { recalcularCoberturas() }}
                        mensajeObservaciones={mensajeObservaciones}
                        requiereObservacion={requiereObservacion}
                        setRequiereObservacion={(valor) => { setRequiereObservacion(valor) }}
                        observacion={observacion}
                        setObservacion={(value) => { setObservacion(value) }}
                        observacionValida={observacionValida}
                        setObservacionValida={(value) => { setObservacionValida(value) }}
                        mensajeObservacion={mensajeObservacion}
                        requiereObservacionObligatoria={requiereObservacionObligatoria}


                    />



                }




                <Card>
                    <CardBody>

                        <Button
                            onClick={() => {

                                onRegresar()

                            }}
                            className="btn btn-purple btn btn-secondary"
                            style={{ marginLeft: "5px" }}
                        >
                            <i class="fa fa-chevron-circle-left" aria-hidden="true" />
                            &nbsp;REGRESAR
                        </Button>
                    </CardBody>
                </Card>



            </Col>


            <Col lg={4}>

                {datosCarrito && datosCarrito.valorTotal &&

                    <ValoresParametrico
                        totales={datosCarrito.valorTotal}
                        paso={'resumen'}
                        loading={loading}
                        disabled={(requiereEmisionRetroactiva && requiereEmision && errorVigenciaRetroactiva)}
                        observacionNoValida={(requiereObservacion && !observacionValida)}
                        setLoading={(valor) => { setLoading(valor) }}
                        idCarrito={datosCarrito._id['$oid']}
                        urlPdf={datosCarrito.carUrlPdf}
                        history={null}
                        duplicada={duplicado}
                        mensajeDuplicado={mensajeDuplicado}
                        observacionValida={observacionValida}
                        setObservacionValida={(value) => { setObservacionValida(value) }}
                        requiereObservacionObligatoria={requiereObservacionObligatoria}
                        observacion={observacion}
                        onClickResumen={async () => {

                            setTieneError(!tieneError)

                            if ((!esRenovacion) || (esRenovacion && !tieneError)) {

                                setLoading(true)
                                if (cotizadorId == 'jeep' || cotizadorId == 'altaGama') {
                                    const url = urlConsultarPlaca + datosCarrito.carPreguntas[0].preguntas[0].value
                                    const response = await fetch(url)
                                    const json = await response.json()
                                    if (json.tienePolizaVigente == true) {
                                        setDuplicado(true)
                                        setMensajeDuplicado(json.errorDescripcion)
                                    } else {
                                        setDuplicado(false)
                                        setMensajeDuplicado('')
                                        guardarInformacion(
                                            {
                                                fechaEmisionRetroactivaFutura: requiereEmision ? moment(new Date(vigenciaRetroactiva)).format('yyyy/MM/DD') : null,
                                                emisionRetroactivaFutura: requiereEmision,
                                                requiereObservacion: requiereObservacion,
                                                observacion: requiereObservacion ? observacion : null
                                            }
                                        )
                                    }
                                    setLoading(false)
                                } else {
                                    setDuplicado(false)
                                    setMensajeDuplicado('')
                                    guardarInformacion(
                                        {
                                            fechaEmisionRetroactivaFutura: requiereEmision ? moment(new Date(vigenciaRetroactiva)).format('yyyy/MM/DD') : null,
                                            emisionRetroactivaFutura: requiereEmision,
                                            requiereObservacion: requiereObservacion,
                                            observacion: requiereObservacion ? observacion : null
                                        }
                                    )
                                    setLoading(false)
                                }

                                if (requiereRenovacion) {
                                    guardarRenovacion(esRenovacion, datosCarrito._id['$oid'], numPolizaVence)
                                }

                            }






                        }}



                    />


                }

            </Col>
        </Row>
    )

}

export default ComponentResumenParametrico